export const DESIGN_W = 1080;
export const DESIGN_H = 1920;
export const MAX_PC_WIDTH = 440;
export const SAFE = 200;

// 會員等級
export const LEVELS = ['一般顧客', '年會員', '資深年會員', '月會員'];
export const levelIndex = (lv='') => {
  const s = String(lv);
  if (/月會員/.test(s))     return 3;
  if (/資深年會員/.test(s)) return 2;
  if (/年會員/.test(s))     return 1;
  return 0; // 一般顧客
};

export const POS = {
  // 分頁（左上錨點）：左右留 50、整體略下移，避免頂到貼紙標題
  tab:    { x: 70,  y: 190, w: 940 },  // 往上移 60px

  // 姓名 / 等級 / 到期（值的左上角）
  name:   { x: 160, y: 580 },  // 往上移 60px
  level:  { x: 520, y: 580 },  // 往上移 60px
  expiry: { x: 735, y: 566 },  // 往上移 60px

  // 三格數字（用中心點便於對齊方框）
  point:  { x: 320, y: 880 },  // 往上移 60px
  pass:   { x: 760, y: 880 },  // 往上移 60px
  money:  { x: 825, y: 880 },  // 往上移 60px

  // 其它區塊基準線
  progressRankY: 320,   // 身分等級進度條（上）往上移 60px
  progressPointY: 1005, // 集點進度條（下）往上移 60px
  infoTop:   1120,      // 往上移 60px
  barcodeY:  1460,      // 往上移 60px
};
